<template>
  <card body-classes="p-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{ title }}</h3>
        </div>

        <div class="col text-right">
          <slot name="actions"></slot>
        </div>
      </div>
    </template>

    <div v-if="showFilters" class="pt-3">
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <base-input label="Items por pagina">
          <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
              class="select-primary"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input v-if="authors.length > 0" label="Autor">
          <el-select v-model="authorFilter" cy-id="author" class="select-primary" placeholder="Autor" value-key="value">
            <el-option :value="null" class="select-primary" label="Todos"></el-option>
            <el-option
              v-for="item in authors"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              class="select-primary"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input v-if="showDateFilter" label="Fecha desde">
          <el-date-picker
            v-model="dateFromFilter"
            cy-id="date-from"
            align="center"
            :editable="false"
            :picker-options="{ shortcuts: shortcuts }"
            class="custom-datepicker"
            suffix-icon="fas fa-calendar-alt"
            type="date"
          >
          </el-date-picker>
        </base-input>

        <base-input v-if="showDateFilter" label="Fecha hasta">
          <el-date-picker
            v-model="dateToFilter"
            align="center"
            :editable="false"
            :picker-options="{ shortcuts: shortcuts }"
            class="custom-datepicker"
            suffix-icon="fas fa-calendar-alt"
            type="date"
          >
          </el-date-picker>
        </base-input>

        <div>
          <base-input
            v-model="mixSearchQuery"
            class="custom-search"
            label="Buscar"
            placeholder="Buscar..."
            prepend-icon="fas fa-search"
          >
          </base-input>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table
        :data="queriedData"
        cy-id="visits-table"
        header-row-class-name="thead-light"
        row-key="id"
        @sort-change="sortChange"
      >
        <el-table-column label="Fecha" min-width="130px" prop="visitDate" sortable>
          <template #default="{ row }">
            <small>
              {{ (row.visitDate || row.appointmentDate) | date('DD/MM/YYYY HH:mm') }}
            </small>
            <!--<badge size="lg" type="success" v-if="row.visitDate" v-text="'realizada'"></badge>-->
            <!--<badge size="lg" type="warning" v-else v-text="'programada'"></badge>-->
          </template>
        </el-table-column>

        <el-table-column label="Autor" min-width="120px" prop="user.name">
          <template #default="{ row }">
            <small v-text="row.user.name"></small>
          </template>
        </el-table-column>

        <el-table-column label="Participantes" min-width="180px" prop="participants">
          <template #default="{ row }">
            <div v-for="participant in row.participants" :key="participant.id">
              <router-link
                v-if="participant && participant.participable"
                class="h5"
                :to="{ name: getParticipantRoute(participant.type), params: { id: participant.participableId } }"
              >
                <span v-if="participant.principal" class="text-primary">●</span>
                <span v-text="participant.participable.name"></span>
                <div v-if="participant.participable.extraFields" class="text-break">
                  <small v-text="participant.participable.extraFields"></small>
                </div>
              </router-link>
            </div>
          </template>
        </el-table-column>

        <el-table-column :formatter="detailFormat" label="Detalle de la visita" min-width="400px" prop="details">
        </el-table-column>

        <el-table-column label="Comentarios" min-width="140px" prop="commentsCount" sortable>
          <template #default="{ row }">
            <badge size="xs" type="danger" v-text="`${row.commentsCount} coment.`"></badge>
            <badge
              v-if="$can('private', 'visits') && !row.share"
              size="xs"
              type="info"
              v-text="`VISITA PRIVADA`"
            ></badge>
          </template>
        </el-table-column>

        <el-table-column label="Próxima Visita" min-width="150px" prop="visitNextDate" sortable>
          <template #default="{ row }">
            <small v-if="row.visitNextDate">
              {{ row.visitNextDate | date('DD/MM/YYYY HH:mm') }}
            </small>
            <small v-else> - </small>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="130px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'visits')"
              :to="{ name: 'VisitShow', params: { id: row.id } }"
              title="info"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'visits')"
              title="danger"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      v-if="showPagination"
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div>
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} visitas</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option, DatePicker } from 'element-ui';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import DateShortcutsMixin from '@/mixins/dateShortcutsMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';
import moment from 'moment';

export default {
  name: 'VisitsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BasePagination,
  },

  mixins: [PaginationOnServerMixin, DateShortcutsMixin, DeleteRowFromTableMixin],
  props: {
    title: {
      type: String,
      default: 'Todas las visitas',
    },

    showFilters: {
      type: Boolean,
      default: true,
    },

    showDateFilter: {
      type: Boolean,
      default: true,
    },

    showPagination: {
      type: Boolean,
      default: true,
    },

    limit: {
      type: Number,
      default: null,
    },

    filterId: {
      type: Number,
      default: null,
    },

    filterType: {
      type: String,
      default: null,
    },

    filterAuthor: {
      type: Number,
      default: null,
    },

    customParams: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tableData: [],
      authors: [],
      authorFilter: null,
      dateFromFilter: '',
      dateToFilter: '',
      shortcutKeys: ['today', 'lastWeek', 'lastMonths:6'],
      routes: {
        sellers: {
          name: 'SellerShow',
          subject: 'sellers',
          action: 'show',
        },

        distributors: {
          name: 'DistributorShow',
          subject: 'distributors',
          action: 'show',
        },

        producers: {
          name: 'ProducerShow',
          subject: 'producers',
          action: 'show',
        },
      },

      modelName: 'visit',
    };
  },

  computed: {
    detailFormat() {
      return ({ details }) => (details.length > 1100 ? details.slice(0, 1100) + '...' : details);
    },
  },

  watch: {
    // TODO clean up (review double call to get visits)
    authorFilter(value) {
      this.pagination.total = 0;
      this.setAuthor(value);
      this.fetchVisits();
    },

    dateFromFilter(newVal) {
      if (newVal !== '') {
        this.pagination.total = 0;
        this.setDateFrom(moment(newVal).format('YYYY-MM-DD'));
        this.fetchTableData();
      }
    },

    dateToFilter(newVal) {
      if (newVal !== '') {
        this.pagination.total = 0;
        this.setDateTo(moment(newVal).format('YYYY-MM-DD'));
        this.fetchTableData();
      }
    },
  },

  created() {
    this.fetchTableData(true);

    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará la visita';
    this.alertSuccessSettings.message = 'La visita ha sido eliminada';
    this.resourceName = 'visits';
  },

  methods: {
    async fetchTableData(fetchAuthors) {
      try {
        const promiseValues = [];

        if (fetchAuthors) {
          promiseValues.push(this.fetchAuthors());
        }
        promiseValues.push(this.fetchVisits());

        await Promise.all(promiseValues);
      } catch (err) {}
    },

    fetchVisits() {
      this.authorFilter = this.author || this.authorFilter;
      this.dateFromFilter = this.dateFrom || this.dateFromFilter;
      this.dateToFilter = this.dateTo || this.dateToFilter;
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const params = {
        include: ['participants.participable', 'user'],
        'filter[participant]': this.filterType && this.filterId ? `${this.filterId}:${this.filterType}` : null,
        'filter[search]': this.mixSearchQuery,
        'filter[user]': this.filterAuthor || this.authorFilter,
        'filter[dateFrom]': this.formatDate(this.dateFromFilter),
        'filter[dateTo]': this.formatDate(this.dateToFilter),
        sort: '-visit_date',
        perPage: this.limit || this.pagination.perPage,
        page: this.pagination.currentPage,
      };

      this.customParams.forEach((param) => {
        params[param.prop] = param.value;
      });

      return this.$services
        .resource('visits')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.visits))
        .catch((err) => {
          this.$error('Fallo al traer las visitas.');
        });
    },

    fetchAuthors() {
      if (this.$can('filter_user', 'visits') && this.showFilters && !this.filterAuthor) {
        return this.$services
          .resource('users')
          .get({ 'filter[hasVisits]': 0, sort: 'name' })
          .then((res) => res.data.data)
          .then((data) => (this.authors = data.users))
          .catch((err) => {
            this.$warning('No tiene permiso para ver autores.');
          });
      }
      return new Promise((resolve) => resolve(true));
    },

    getParticipantRoute(participantType) {
      let route = this.routes[participantType];

      if (this.$can(route.action, route.subject)) {
        return route.name;
      }

      return null;
    },

    formatDate(date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD');
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: break-word;
}

.custom-datepicker {
  input[type='text'] {
    height: 43px;
  }
}

.custom-search {
  input[type='text'] {
    height: 43px;
  }
}
</style>
